import React from "react";

export default (props) => (
  <div className="custom-block"
       dangerouslySetInnerHTML={{ __html: props.content.text }} />
)